export default "__VITE_ASSET__BZVjCrFk__"